"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Overlay = Overlay;
exports.HeartWipe = HeartWipe;
exports.withHeartWipe = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactAnime = require("react-anime");

var _Overlay = require("./Overlay");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Overlay(props) {
  return /*#__PURE__*/_react.default.createElement(_Overlay.Overlay, props, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: "flex",
      width: "100%",
      height: "100%",
      justifyContent: "center"
    }
  }, /*#__PURE__*/_react.default.createElement(HeartCutout, {
    color: props.color
  })));
}

function HeartCutout(_ref) {
  var color = _ref.color;

  var ref = _react.default.useRef(null);

  _react.default.useEffect(function () {
    if (ref.current) {
      var basicTimeline = _reactAnime.anime.timeline();

      basicTimeline.add({
        targets: ref.current,
        scale: [0, 3],
        duration: 3000,
        easing: "easeOutSine"
      });
    }
  }, [ref]);

  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "Heart-cutout-svg",
    ref: ref,
    width: "100%",
    height: "100%",
    viewBox: "0 0 450 400"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M446,59.05c2.38,12.19,2.65,24.79,3.88,37.2-1.15,26.76-4.87,52.89-12.53,78.44-10.79,36-23.45,71.38-40.76,104.82-13.06,25.22-27.55,49.94-47.61,70.18-15.47,15.6-33.31,28.89-50.41,42.82-7,5.69-15.45,7-24,4-12.09-4.34-24.17-8.78-36-13.82-65.2-27.84-125.44-63.89-177.31-112.43C22.66,234.11,0,189.45,0,135.42A143.6,143.6,0,0,1,5.06,97.27C16.86,55,47.28,31.47,88.32,22.12,132.67,12,172.83,23.81,208.77,51.18c4.87,3.71,10.62,6.27,16,9.27,4.72,2.63,8.14.7,11.6-2.89,18.92-19.65,41.35-34.16,66.35-44.88a151.6,151.6,0,0,1,82-11.18C415,5.72,440.2,29.22,446,59.05ZM432.2,118.87c2.63-18.92,2.67-38.24-1.28-57.23-4.67-22.46-24.2-42.9-45.41-46.34A134.29,134.29,0,0,0,319.13,21a185.63,185.63,0,0,0-72.3,45.59c-2.57,2.62-5.18,5.61-8.39,7-3.06,1.37-7.24,2-10.38,1.11a243.1,243.1,0,0,1-24.84-9.13c-3.66-1.54-7.62-3.49-10.17-6.38-8.42-9.54-19.32-15.45-30.39-20.66-15.28-7.21-31.95-7.86-48.67-7.74-24.15.17-45.54,8-64.46,22.61C39.2,61.4,30.18,70.72,26.11,84L45.46,65.34c-6.54,9.88-14.41,18.41-22.22,27-6.3,6.92-8.73,16.49-6.89,26.62l33.81-41,1.61,1.23c-2.2,3.22-4.27,6.53-6.61,9.63-8.22,10.89-16.13,22-24.91,32.45-8,9.55-9.09,19.59-4.62,31.81,9.56-15.25,18.67-30,31.74-41.8a38,38,0,0,1-4.75,9.42C34.83,132.73,27.29,145,19.05,156.74c-3.15,4.49-3.11,8.48-2,13.3,5.69,25.22,15.93,48.22,32.7,68.08a58.22,58.22,0,0,0,5.08,4.76c12-18.9,23.63-37,35.22-55.2l2.39,1.42C83,210,68.71,228.34,58.34,249.66L71.48,262.1l29.85-51,2.27,1.26c-7,18.84-19.49,35.08-27.58,54.32l14.21,11.93,30.22-53L123,227,94.16,282.39l13.24,10.07a393.26,393.26,0,0,1,29.43-49.81l2.26,1.33L111,295.36,128,307c8.31-14.62,16.2-28.52,24.09-42.42l2.59,1.33-21.48,44.52L149,320.39,172,279l2.29,1.22-20.89,43,33,19.18c4.54-14.12,11.89-26,19.3-37.84l2.4,1.19-18.9,38.44,15.17,7.66,22.84-41.09,2.34,1.19c-6.68,14-13.36,28-20.33,42.62l13.24,5.26c5.77-10.53,11-20.1,16.24-29.67l2.16,1-13.95,31.15,7.13,2.3,16.13-30.06,2.26,1.11L238.4,367.4l18.08,7.22L266.31,356l1.45.63c-2.56,6.22-5.11,12.45-8.29,20.18,6.85,2.18,12.9,4.79,19.2,5.82A16.49,16.49,0,0,0,290,380.16C313.57,363,336.45,345,353.29,320.65,395.49,259.6,422,192.33,432.2,118.87Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: color ? color : "#c1272d",
    d: "M430.92,61.64c3.95,19,3.91,38.31,1.28,57.23C422,192.33,395.49,259.6,353.29,320.65,336.45,345,313.57,363,290,380.16a16.49,16.49,0,0,1-11.29,2.44c-6.3-1-12.35-3.64-19.2-5.82,3.18-7.73,5.73-14,8.29-20.18l-1.45-.63-9.83,18.65L238.4,367.4l14.06-31.71-2.26-1.11-16.13,30.06-7.13-2.3,13.95-31.15-2.16-1c-5.24,9.57-10.47,19.14-16.24,29.67l-13.24-5.26C216.22,340,222.9,326,229.58,312l-2.34-1.19L204.4,351.87l-15.17-7.66,18.9-38.44-2.4-1.19c-7.41,11.84-14.76,23.72-19.3,37.84l-33-19.18,20.89-43L172,279,149,320.39l-15.76-9.94,21.48-44.52-2.59-1.33C144.19,278.5,136.3,292.4,128,307l-17-11.66L139.09,244l-2.26-1.33a393.26,393.26,0,0,0-29.43,49.81L94.16,282.39,123,227l-2.53-1.37-30.22,53L76,266.71c8.09-19.24,20.54-35.48,27.58-54.32l-2.27-1.26-29.85,51L58.34,249.66C68.71,228.34,83,210,92.42,189.1L90,187.68c-11.59,18.15-23.17,36.3-35.22,55.2a58.22,58.22,0,0,1-5.08-4.76C33,218.26,22.72,195.26,17,170c-1.09-4.82-1.13-8.81,2-13.3,8.24-11.76,15.78-24,23.57-36.08a38,38,0,0,0,4.75-9.42C34.3,123,25.19,137.79,15.63,153c-4.47-12.22-3.42-22.26,4.62-31.81C29,110.81,36.94,99.67,45.16,88.78c2.34-3.1,4.41-6.41,6.61-9.63l-1.61-1.23-33.81,41c-1.84-10.13.59-19.7,6.89-26.62,7.81-8.57,15.68-17.1,22.22-27L26.11,84C30.18,70.72,39.2,61.4,49.53,53.42,68.45,38.8,89.84,31,114,30.81c16.72-.12,33.39.53,48.67,7.74,11.07,5.21,22,11.12,30.39,20.66,2.55,2.89,6.51,4.84,10.17,6.38a243.1,243.1,0,0,0,24.84,9.13c3.14.91,7.32.26,10.38-1.11,3.21-1.44,5.82-4.43,8.39-7A185.63,185.63,0,0,1,319.13,21a134.29,134.29,0,0,1,66.38-5.67C406.72,18.74,426.25,39.18,430.92,61.64ZM172.4,328.26c9.7-11,18-28.8,18.48-37.71C183.27,303.12,176.07,314.82,172.4,328.26ZM36.2,205.3q18-31.73,36-63.45l-2.82-1.69C58.57,158.35,47.62,176.46,37,194.79c-1.69,2.92-1.72,6.79-2.51,10.22Zm24.95-77.1-2.27-1.48c-6.12,8.85-12.44,17.57-18.32,26.58-14.23,21.79-14.15,21.84-13.4,30Zm-9.06,92.65,27.12-46.51C61.41,191.93,50.7,211.56,52.09,220.85Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M190.88,290.55c-.44,8.91-8.78,26.73-18.48,37.71C176.07,314.82,183.27,303.12,190.88,290.55Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M72.22,141.85q-18,31.72-36,63.45L34.53,205c.79-3.43.82-7.3,2.51-10.22,10.58-18.33,21.53-36.44,32.36-54.63Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M58.88,126.72l2.27,1.48-34,55.1c-.75-8.16-.83-8.21,13.4-30C46.44,144.29,52.76,135.57,58.88,126.72Z"
  }), " d=\"M79.21,174.34,52.09,220.85C50.7,211.56,61.41,191.93,79.21,174.34Z\"/>");
}

function HeartWipe(_ref2) {
  var color = _ref2.color,
      children = _ref2.children,
      _ref2$message = _ref2.message,
      message = _ref2$message === void 0 ? '' : _ref2$message;
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(Overlay, {
    color: color,
    start: true,
    message: message
  }), children);
}

var withHeartWipe = function withHeartWipe(Component, color) {
  var message = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return function (_ref3) {
    var props = _extends({}, _ref3);

    return /*#__PURE__*/_react.default.createElement(HeartWipe, {
      color: color,
      message: message
    }, /*#__PURE__*/_react.default.createElement(Component, props));
  };
};

exports.withHeartWipe = withHeartWipe;